var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-calendar"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    clipPath: "url(#clip-calendar)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16878",
    "data-name": "Group 16878",
    transform: "translate(-1132.144 -557.576)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar_2_",
    "data-name": "calendar(2)",
    transform: "translate(1132.568 558)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_18546",
    "data-name": "Path 18546",
    d: "M13.2,1.184H11.838V.474a.474.474,0,1,0-.947,0v.71H4.262V.474a.474.474,0,1,0-.947,0v.71H1.953A1.955,1.955,0,0,0,0,3.137V13.2a1.955,1.955,0,0,0,1.953,1.953H13.2A1.955,1.955,0,0,0,15.152,13.2V3.137A1.955,1.955,0,0,0,13.2,1.184ZM1.953,2.131H3.315V2.6a.474.474,0,1,0,.947,0V2.131h6.629V2.6a.474.474,0,0,0,.947,0V2.131H13.2a1.007,1.007,0,0,1,1.006,1.006V4.262H.947V3.137A1.007,1.007,0,0,1,1.953,2.131ZM13.2,14.205H1.953A1.007,1.007,0,0,1,.947,13.2V5.209H14.205V13.2A1.007,1.007,0,0,1,13.2,14.205Z",
    fill: "#3A6B60",
    stroke: "#3A6B60",
    strokeWidth: 0.28
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_24188",
    "data-name": "Rectangle 24188",
    width: 7.874,
    height: 1.125,
    rx: 0.562,
    transform: "translate(1136.428 566.999)",
    fill: "#3A6B60"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.4e5ef69b5add2fcd48daae89074e2872.svg";
export { ForwardRef as ReactComponent };